/**
 * The signed-in person's /me answer, as one load that every reader shares. StoreProvider keeps
 * it read for the whole sign-in (hooks/useSessionMe.ts), so a reader that mounts later reads the
 * boot load.
 */

import { atom } from 'jotai';

import { snapshotAtoms } from '../snapshotAtoms';
import { api } from '@/api';
import type { MeSnapshot } from '@/types/auth';
import { type StreamInput, StreamInputKind } from '@/types/notifications';

const PENDING: MeSnapshot = { me: null, isLoading: true, error: null };

const me = snapshotAtoms<MeSnapshot>(PENDING, async (): Promise<MeSnapshot> => {
    return { me: await api.getMe(), isLoading: false, error: null };
});

export const meAtom = me.value;

/** What the notifications stream means for /me. */
export const meStreamAtom = atom(null, (get, set, input: StreamInput): void => {
    // /me has no change frames, so a gap hides nothing; a reopened stream only says that the
    // network is back for a load that failed.
    if (input.kind === StreamInputKind.Reopened && get(meAtom).error !== null) {
        set(me.reload);
    }
});
